import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CalAngularService } from '@cvx/cal-angular';
import { PageLayout } from '@cvx/nextpage';
import { lastValueFrom } from 'rxjs';
import { PrimaryUser } from 'src/app/models/primaryUser';
import { PrimaryUserService } from 'src/app/services/primaryUser/primaryUser.service';
import { PrimaryUserAuthService } from 'src/app/services/primaryUserAuth/primaryUserAuth.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-manage-primary-user',
  templateUrl: './manage-primary-user.component.html'
})
export class ManagePrimaryUserComponent implements OnInit{

  constructor(
    private authService: CalAngularService, 
    private primaryUserAuthService: PrimaryUserAuthService, 
    private primaryUserService: PrimaryUserService,
    private route: ActivatedRoute
  ) { }
  
  PageLayout = PageLayout;
  searchResults: PrimaryUser[] = [];
  selectedUser?: PrimaryUser;

  IsAuthorised = false;

  async ngOnInit(): Promise<void> {
    const cvxClaimsPrincipal = this.authService.cvxClaimsPrincipal;
    this.IsAuthorised = this.primaryUserAuthService.GetPageAuthorization(cvxClaimsPrincipal);

    const provisioningId = this.route.snapshot.queryParamMap.get('provisioningid')
    const token = await lastValueFrom(this.authService.getAADToken(environment.tokenScopes));
    if (provisioningId != null) {
      this.primaryUserService.GetPrimaryUsers(`provisioningId=${provisioningId}`, token, "active")
          .subscribe({
              next: (user) => {
                  this.selectedUser=user.data[0];
              },
              error: (err: any) =>{console.log(err)}
          });           
    }
  }

  whenSearchComplete(eventData: { searchResults: PrimaryUser[] }) {
    this.searchResults = eventData.searchResults;
  }

  whenUserSelected(eventData: { selectedUser: PrimaryUser }) {
    this.selectedUser = eventData.selectedUser
  }

  cancel() {
    delete this.selectedUser;
    this.searchResults = [];
  }
}
